import React, { useMemo, useState } from 'react'
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';

import { BlobProvider } from '@react-pdf/renderer';
import QuotationPDF from './component/QuotationPDF';

const QuotationForm = () => {
    const { id } = useParams()
    const [data, setdata] = useState(null)
    const [loadingData, setLoadingData] = useState(true)
    const [loadError, setLoadError] = useState('')

    const getquotationform = async () => {
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };

        setLoadingData(true)
        setLoadError('')

        try {
            const response = await fetch(
                process.env.REACT_APP_HAPS_MAIN_BASE_URL + `quotation/quotationById/${id}`,
                requestOptions
            )
            const result = await response.json()

            if (!response.ok || result.status !== 200 || !result.data) {
                throw new Error(result.message || 'Unable to load this quotation.')
            }

            setdata(result.data)
        } catch (error) {
            setLoadError(error.message || 'Unable to load this quotation.')
        } finally {
            setLoadingData(false)
        }
    }
    useEffect(() => {
        getquotationform();
    }, [id])
    const numberToWords = require('number-to-words');

    // Assuming data.total_amount is a number
    const totalAmount = data?.grand_total ? data?.grand_total : 0;

    // Convert the number to its text representation
    const totalAmountInWords = numberToWords.toWords(totalAmount);

    const timelines = data?.timelines || []
    const maxDays = timelines.reduce((max, timeline) => Math.max(max, parseInt(timeline.days, 10) || 0), 0)
    const quotationDocument = useMemo(() => data ? (
        <QuotationPDF
            data={data}
            totalAmountInWords={totalAmountInWords}
            maxDays={maxDays}
        />
    ) : null, [data, totalAmountInWords, maxDays])

    return (
        <DashboardLayout>
            <DashboardNavbar />
            {loadingData ? <p>Loading quotation...</p> : null}
            {!loadingData && loadError ? <p role="alert">{loadError}</p> : null}
            {!loadingData && !loadError && quotationDocument ? (
            <BlobProvider
                document={quotationDocument}
            >
                {({ url, loading, error }) =>
                    loading ? (
                        <p>Loading document...</p>
                    ) : error ? (
                        <p>Failed to load document: {error.message}</p>
                    ) : (
                        <div>
                            {/* View PDF */}
                            <iframe
                                key={id}
                                title={`Quotation ${data?.id || id}`}
                                src={url}
                                width="100%"
                                height="800px"
                                style={{ border: 0 }}
                            />

                            {/* Download PDF */}
                            <a
                                href={url}
                                download={`${data?.customer_name}_${data?.created_at}.pdf`}
                                style={{ display: 'block', marginTop: '10px', textAlign:'center' }}
                            >
                                Download PDF
                            </a>
                        </div>
                    )
                }
            </BlobProvider>
            ) : null}
        </DashboardLayout >

    )
}


export default QuotationForm
